import { observable, action, computed } from 'mobx';
import lodash from 'lodash';
import axios from '../lib/axios';

class CourseStore {
  @observable categories;
  @observable courses;
  @observable categoryId;
  @observable course;
  @observable lessonId;

  @action fetch() {
    this.categories = this.courses = this.lessonId = undefined;
    axios.get('/courses').then((result) => {
      this.categories = result.data.courseCategories;
      this.courses = result.data.courses;
    });
  }

  @action filterCategory(categoryId) {
    this.categoryId = categoryId;
  }

  @action clearFilterCategory() {
    this.categoryId = undefined;
  }

  @action nextLesson() {
    axios.post(`/courses/${this.course.id}/next_lesson`, {
      lesson_id: this.currentLesson.id
    }).then(({data}) => {
      if (data) {
        this.selectCourse(this.course.slug)
        if (data.status === 'finished') {
          this.fetch();
        }
        else {
          this.selectLesson(data.current_lesson_id);
        }
      }
    })
  }

  @action selectCourse(slug) {
    this.course = undefined;
    axios.get(`/courses/${slug}`).then((result) => {
      this.course = result.data;

      if (!this.course.course_enrollment || !this.course.course_enrollment.status) {
        axios.post(`/courses/${this.course.id}/subscribe`).then(({ data }) => {
          if (data) { 
            this.selectCourse(this.course.id)
          }
        });
      }

      if (this.course.course_enrollment && this.course.course_enrollment.current_lesson_id) {
        this.lessonId = this.course.course_enrollment.current_lesson_id;    
      }
    });
  }


  @action selectLesson(lessonId) {
    this.lessonId = lessonId
  }

  @computed get currentLesson() {
    if (!this.course)
      return null;
    
    if (!this.lessonId)
      return this.course.course_lessons[0];

    return this.course.course_lessons.find(lesson => lesson.id === this.lessonId);
  }

  @computed get items() {
    if (this.isLoading)
      return [];
    const courses = this.categoryId ?
                  this.courses.filter((course) => course.category_id === this.categoryId) :
                  this.courses;
    return courses.map(course => {
      let progress = 0;
      if (course.course_enrollment) {
        if (course.course_enrollment.status === 'finished') { progress = 100; }
        if (course.course_enrollment.status === 'started' && course.course_lessons.length > 0) {
          const lessonPos = course.course_lessons.findIndex(i => i.id === course.course_enrollment.current_lesson_id);
          progress = ((lessonPos/course.course_lessons.length) * 100);
        }
      }
      
      course.progress = progress;
      return course;
    });
  }

  @computed get isLoading() {
    return (!this.courses || !this.categories);
  }
}

export default new CourseStore();



// WEBPACK FOOTER //
// ./src/stores/CourseStore.js